import { AlertTost, CustomModal, TextEditor } from "#components";
import useGet from "#hooks/useGet.js";
import usePost from "#hooks/usePost.js";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import "quill/dist/quill.snow.css";
import { ContentSkeleton } from "#skeleton";

const TermsConditionsComponent = () => {
  const [open, setOpen] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState("");

  // Fetching content
  const {
    data: contentData,
    isLoading: isContentLoading,
    refetch: refetchContent,
  } = useGet(ENDPOINTS.CONTENT_GET, QUERY_KEYS.CONTENT_GET_QUERY_KEY, {
    type: 1,
  });

  // Posting content
  const { mutateAsync: addContentMutateAsync, isLoading: isLoadingAddContent } =
    usePost(ENDPOINTS.ADD_CONTENT, QUERY_KEYS.ADD_CONTENT_QUERY_KEY);

  // Open modal handler
  const onOpen = () => {
    setOpen(true);
  };

  // Close modal handler
  const onClose = () => {
    setOpen(false);
  };

  // Handle form submission
  const handleSubmitTermAndConditions = async () => {
    const data = {
      type: 1,
      content: termsAndConditions,
    };

    try {
      const response = await addContentMutateAsync(data);
      AlertTost(response?.message, "success");
      onClose("add");
      refetchContent();
    } catch (error) {
      toast.dismiss();
      AlertTost(
        error?.response?.data?.message || "Something went wrong!",
        "error"
      );
    }
  };

  const handleChange = (value) => {
    setTermsAndConditions(value);
  };
  useEffect(() => {
    if (contentData?.data?.content) {
      setTermsAndConditions(contentData?.data?.content);
    }
  }, [contentData]);

  return (
    <div className="tab-content-wrapper">
      <div className="row">
        <div className="col-xl-12">
          <div className="sub-heading flex-box">
            <h2>Terms & Conditions</h2>
            <div className="side-content-blk">
              <button className="primary-btn" onClick={() => onOpen("add")}>
                {termsAndConditions === "" ? " Add" : "Edit"}
              </button>
            </div>
          </div>
          <div className="d-flex flex-column w-100" style={{ height: "45vh" }}>
            {isContentLoading ? (
              <ContentSkeleton />
            ) : (
              <div
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  borderRadius: "5px",
                  backgroundColor: "#f9f9f9",
                }}
                dangerouslySetInnerHTML={{
                  __html: contentData?.data?.content,
                }}
              />
            )}
          </div>
        </div>
      </div>

      <CustomModal
        open={open}
        title="Terms & Conditions"
        onClose={() => onClose()}
        loading={isLoadingAddContent}
        onSubmit={handleSubmitTermAndConditions}
        actionButtonTitle="Save"
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            <TextEditor
              stateKey="termsAndConditions"
              index={1}
              value={termsAndConditions}
              handleChange={handleChange}
            />
          </div>
        </div>
      </CustomModal>
    </div>
  );
};

export default TermsConditionsComponent;
